/* eslint-disable no-trailing-spaces */
<template>
  <div class="container">
    <!-- 星星动画背景 -->
    <div class="stars-background">
      <div class="star" v-for="n in 50" :key="n" :style="getStarStyle(n)"></div>
    </div>
    
    <!-- 浮动粒子效果 -->
    <div class="particles">
      <div class="particle" v-for="n in 20" :key="n" :style="getParticleStyle(n)"></div>
    </div>
    
    <audio ref="audioPlayer" src="/static/music.mp3" preload="auto"></audio>
    <div class="panel settings-panel">
      <h2>平台与授权</h2>
      <!-- 平台选择单独一行 -->
      <div class="form-group">
        <label for="clubSelector">选择平台/俱乐部</label>
        <!-- 固定俱乐部为怪兽三角洲，禁用修改 -->
        <input type="text" value="怪兽三角洲" disabled>
      </div>
      <!-- 用户ID和令牌放在一行 -->
      <div class="form-group form-row">
        <div class="form-item">
          <label for="userId">用户ID</label>
          <input type="text" v-model="config.userId" placeholder="请输入用户ID">
        </div>
        <div class="form-item">
          <label for="userToken">用户令牌</label>
          <input type="password" v-model="config.userToken" placeholder="请输入用户令牌">
        </div>
      </div>
      <!-- 验证令牌按钮 -->
      <div class="form-group">
        <button @click="verifyToken" class="btn-verify" :disabled="isVerifying || !config.userId || !config.userToken || !selectedClub">
          {{ isVerifying ? '验证中...' : '验证令牌' }}
        </button>
      </div>
      <!-- 手机号登录按钮 -->
      <div class="form-group">
        <button @click="showPhoneLoginDialog" class="btn-phone-login" :disabled="!selectedClub">
          手机号登录
        </button>
      </div>

      <h2>抢单设定</h2>
      <!-- 匹配关键词和不匹配关键词放在一行 -->
      <div class="form-group form-row">
        <div class="form-item">
          <label class="checkbox-label">
            <input type="checkbox" v-model="config.matchKeywords" id="matchKeywords">
            匹配关键词
          </label>
          <input type="text" v-model="config.keywords" placeholder="多个关键词用 | 分隔, 如 A|B|C">
        </div>
        <div class="form-item">
          <label class="checkbox-label">
            <input type="checkbox" v-model="config.excludeKeywords" id="excludeKeywords">
            不匹配关键词
          </label>
          <input type="text" v-model="config.excludeKeywordsList" placeholder="包含这些关键词的订单不会抢, 用 | 分隔">
        </div>
      </div>
      <!-- 匹配老板和匹配价格放在一行 -->
      <div class="form-group form-row">
        <div class="form-item">
          <label class="checkbox-label">
            <input type="checkbox" v-model="config.matchBoss" id="matchBoss">
            匹配老板
          </label>
          <input type="text" v-model="config.bossKeywords" placeholder="多个老板等级用 | 分隔">
        </div>
        <div class="form-item">
          <label class="checkbox-label">
            <input type="checkbox" v-model="config.matchPrice" id="matchPrice">
            匹配价格
          </label>
          <input type="number" v-model="config.minFee" value="0" placeholder="服务费需大于此金额">
        </div>
      </div>
   

      <h2>过滤设定</h2>
      <!-- 服务器类型和排除有备注的订单放在一行 -->
      <div class="form-group form-row">
        <div class="form-item">
          <label for="serverTypeFilter">选择服务器类型</label>
          <select v-model="config.serverTypeFilter" id="serverTypeFilter">
            <option value="全部">全部</option>
            <option value="手机端">手机端</option>
            <option value="电脑端">电脑端</option>
            <option value="QQ区">QQ区</option>
            <option value="微信区">微信区</option>
          </select>
        </div>
        <div class="form-item">
          <label class="checkbox-label">
            <input type="checkbox" v-model="config.excludeWithRemarks" id="excludeWithRemarks">
            排除有备注的订单
          </label>
        </div>
      </div>
      <!-- 过滤备注关键词 -->
      <div class="form-group">
        <label class="checkbox-label">
          <input type="checkbox" v-model="config.filterRemarks" id="filterRemarks">
          过滤备注关键词
        </label>
        <input type="text" v-model="config.remarkFilterKeywords" placeholder="包含这些关键词的备注将被过滤, 用 | 分隔">
      </div>
      
      <h2>高级设定</h2>
      <!-- 验证码类型占一半宽度 -->
      <div class="form-group form-row">
        <div class="form-item" style="max-width: 50%;">
          <label for="captchaType">验证码类型</label>
          <!-- 固定验证码类型为无验证码，禁用修改 -->
          <input type="text" value="无验证码" disabled>
        </div>
        <div class="form-item"></div>
      </div>
      <!-- 刷新延迟和抢单延迟放在一行 -->
      <div class="form-group form-row">
        <div class="form-item">
          <label for="refreshDelay">刷新延迟 (毫秒)</label>
          <input type="number" v-model="config.refreshDelay" value="2000">
        </div>
        <div class="form-item">
          <label for="grabDelay">抢单延迟 (毫秒)</label>
          <input type="number" v-model="config.grabDelay" value="500" min="0" step="1">
        </div>
      </div>
      <div class="form-group-row" style="justify-content: space-around; margin-top: 8px;">
        <button @click="startGrabbing" class="btn-start" :disabled="isGrabbing">开始抢单</button>
        <button @click="stopGrabbing" class="btn-stop" :disabled="!isGrabbing">停止抢单</button>
        <button @click="showMyOrders" class="btn-view">查看待完成订单</button>
        <button @click="testPlayMusic" class="btn-test">测试音乐</button>
      </div>
      
      <!-- 手机版专用：日志输出和订单列表 -->
      <div class="mobile-only-content">
        <h2>日志输出</h2>
        <div class="log-box" ref="logBoxMobile">
          <div v-for="(log, index) in logs" :key="index" v-html="log"></div>
        </div>
        
        <h2>可抢订单列表 (自动刷新)</h2>
        <div style="overflow-x: auto;">
          <table>
            <thead>
              <tr>
                <th>区服</th>
                <th>商品名</th>
                <th>数量</th>
                <th>备注</th>
                <th>原价</th>
                <th>服务费</th>
                <th>老板</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in orders" :key="order.id">
                <td>{{ order.game_server_name || '' }}</td>
                <td>{{ order.goods_name || '' }}</td>
                <td>{{ order.goods_num || '' }}</td>
                <td>{{ order.remarks || '' }}</td>
                <td>{{ order.original_price || '' }}</td>
                <td>{{ order.servant_fee || '' }}</td>
                <td>{{ (order.user_info && order.user_info.user_level && order.user_info.user_level.name) || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="panel main-panel desktop-only-content">
      <h2>日志输出</h2>
      <div class="log-box" ref="logBox">
        <div v-for="(log, index) in logs" :key="index" v-html="log"></div>
      </div>
      
      <h2>可抢订单列表 (自动刷新)</h2>
      <div style="overflow-x: auto;">
        <table>
          <thead>
            <tr>
              <th>区服</th>
              <th>商品名</th>
              <th>数量</th>
              <th>备注</th>
              <th>原价</th>
              <th>服务费</th>
              <th>老板</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>{{ order.game_server_name || '' }}</td>
              <td>{{ order.goods_name || '' }}</td>
              <td>{{ order.goods_num || '' }}</td>
              <td>{{ order.remarks || '' }}</td>
              <td>{{ order.original_price || '' }}</td>
              <td>{{ order.servant_fee || '' }}</td>
              <td>{{ (order.user_info && order.user_info.user_level && order.user_info.user_level.name) || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 添加待完成订单弹窗 -->
    <div v-if="showOrdersModal" class="modal-overlay" @click="closeOrdersModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2>我的待完成订单</h2>
          <button class="close-btn" @click="closeOrdersModal">&times;</button>
        </div>
        <div class="modal-body">
          <div style="overflow-x: auto;">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>订单号</th>
                  <th>创建时间</th>
                  <th>区服</th>
                  <th>商品名</th>
                  <th>备注</th>
                  <th>原价</th>
                  <th>服务费</th>
                  <th>游戏ID</th>
                  <th>游戏名</th>
                  <th>手机号</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(order, index) in myOrders" :key="order.order_no">
                  <td>{{ index + 1 }}</td>
                  <td>{{ order.order_no }}</td>
                  <td>{{ formatTime(order.create_time) }}</td>
                  <td>{{ order.game_server_name }}</td>
                  <td>{{ order.goods_name }}</td>
                  <td>{{ order.remarks }}</td>
                  <td>{{ order.original_price }}</td>
                  <td>{{ order.servant_fee }}</td>
                  <td>{{ order.game_id }}</td>
                  <td>{{ order.extra_from_data && order.extra_from_data[0] ? order.extra_from_data[0].value : '' }}</td>
                  <td>{{ order.user_info ? order.user_info.phone : '' }}</td>
                  <td>
                    <button class="btn-copy" @click="copyOrderInfo(order)">复制信息</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机号登录弹窗 -->
    <div v-if="phoneLoginDialog.visible" class="phone-login-overlay" @click="closePhoneLoginDialog">
      <div class="phone-login-dialog" @click.stop>
        <div class="dialog-header">
          <h3>手机号登录</h3>
          <button class="close-btn" @click="closePhoneLoginDialog">×</button>
        </div>
        <div class="dialog-content">
          <div class="form-group">
            <label>手机号</label>
            <input 
              type="text" 
              v-model="phoneLoginDialog.phone" 
              placeholder="请输入手机号"
              maxlength="11"
            >
          </div>
          <div class="form-group">
            <label>短信验证码</label>
            <div class="sms-input-group">
              <input 
                type="text" 
                v-model="phoneLoginDialog.smsCode" 
                placeholder="请输入短信验证码"
                maxlength="6"
              >
              <button 
                class="get-sms-btn" 
                @click="getSmsCode" 
                :disabled="phoneLoginDialog.smsCountdown > 0 || !phoneLoginDialog.phone || phoneLoginDialog.gettingSms"
              >
              {{ phoneLoginDialog.smsCountdown > 0 ? phoneLoginDialog.smsCountdown + 's' : (phoneLoginDialog.gettingSms ? '获取中...' : '获取验证码') }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <button 
              class="login-btn" 
              @click="phoneLogin" 
              :disabled="!phoneLoginDialog.phone || !phoneLoginDialog.smsCode || phoneLoginDialog.logging"
            >
              {{ phoneLoginDialog.logging ? '登录中...' : '确定登录' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片验证码输入弹窗（直连模式下使用） -->
    <div v-if="imageCaptchaDialog.visible" class="phone-login-overlay" @click="closeImageCaptchaDialog">
      <div class="phone-login-dialog" @click.stop>
        <div class="dialog-header">
          <h3>请输入图片验证码</h3>
          <button class="close-btn" @click="closeImageCaptchaDialog">×</button>
        </div>
        <div class="dialog-content">
          <div class="form-group" style="text-align:center;">
            <!-- 展示验证码图片 -->
            <img :src="imageCaptchaDialog.imageBase64Url" alt="验证码" style="max-width:100%;height:auto;border:1px solid #eee;border-radius:6px;padding:6px;background:#fff;" />
          </div>
          <div class="form-group">
            <label>验证码</label>
            <input 
              type="text" 
              v-model="imageCaptchaDialog.code" 
              placeholder="请输入图片中的字符"
              maxlength="8"
            >
          </div>
          <div class="form-group">
            <button 
              class="login-btn" 
              @click="submitImageCaptcha" 
              :disabled="!imageCaptchaDialog.code || imageCaptchaDialog.submitting"
            >
              {{ imageCaptchaDialog.submitting ? '提交中...' : '提交验证码' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import proxyConfig from '@/config/proxyConfig'

export default {
  name: 'DeltaGrabToolMain',
  data () {
    return {
      clubs: [
        { prefix: 'ncz-sjz', name: '农场主' }, { prefix: 'realdj', name: 'real电竞' },
        { prefix: 'rrsjz', name: 'RR三角洲' }, { prefix: 'htdj', name: '航天电竞' },
        { prefix: 'xjbdj-h4sjz', name: 'H4电竞' }, { prefix: 'sssjz727', name: '鼠鼠三角洲' },
        { prefix: 'hssjz', name: '黑鲨三角洲' }, { prefix: 'dcsjz', name: '得吃三角洲' },
        { prefix: 'sydj', name: '三叶电竞' }, { prefix: 'gssjzdj', name: '怪兽三角洲' },
        { prefix: 'qmsjz', name: '全民三角洲' }, { prefix: 'v8sjz', name: 'V8三角洲' },
        { prefix: 'kejisjz', name: '科技三角洲' }, { prefix: 'nbthp', name: '牛霸天和平' },
        { prefix: 'keghpdj', name: 'keg和平' },{ prefix: '480dj85a', name: '480电竞' },
        { prefix: '686dj', name: '686电竞' }, { prefix: 'brjlb', name: '冰刃俱乐部' }
        ,{ prefix: 'lhdj', name: 'LH电竞' },{ prefix: 'reyoudj', name: '热油电竞' }
        ,{ prefix: 'xiaochou', name: '小丑电竞' }
      ],
      selectedClub: 'gssjzdj',
      baseDomain: 'guaishouyiyou.cn',
      isGrabbing: false,
      isVerifying: false,
      logs: [],
      orders: [],
      config: {
        userId: '',
        userToken: '',
        matchKeywords: false,
        keywords: '',
        matchBoss: false,
        bossKeywords: '',
        matchPrice: false,
        minFee: 0,
        excludeKeywords: false, // 是否启用不匹配关键词过滤
        excludeKeywordsList: '', // 不匹配关键词列表，用|分隔
        serverTypeFilter: '全部', // 服务器类型过滤：手机端, 电脑端, QQ区, 微信区

        excludeWithRemarks: false,
        filterRemarks: false,
        remarkFilterKeywords: '',
        captchaType: 'none', // 验证码类型：none-无验证码, slider-滑块验证码
        ocrApiUrl: 'https://frp-gap.com:30507/api/ocr/alphabet',
        refreshDelay: 2000,
        grabDelay: 500 // 抢单延迟（毫秒）：发现符合条件订单后等待的毫秒数
      },
      showOrdersModal: false,
      myOrders: [],
      copyTemplate: '订单号：{ordernum}\n游戏ID：{nameid}\n游戏名：{gamename}\n手机号：{phone}',
      musicPlayCount: 0,
      isPlayingMusic: false,
      isContinuousPlay: false,
      playNextHandler: null,
      // 手机号登录弹窗相关数据
      phoneLoginDialog: {
        visible: false,
        phone: '',
        smsCode: '',
        gettingSms: false,
        logging: false,
        smsCountdown: 0,
        countdownTimer: null
      },
      // 图片验证码弹窗相关数据（直连模式下使用）
      imageCaptchaDialog: {
        visible: false, // 是否显示弹窗
        imageBase64Url: '', // 验证码图片的base64地址（带data:image/...前缀）
        code: '', // 用户输入的验证码
        submitting: false, // 是否正在提交
        _resolver: null // Promise 解析器，用于 await 用户输入
      }
    }
  },
  created () {
    // 初始化固定俱乐部与验证码类型
    // 说明：俱乐部固定为“怪兽三角洲”(gssjzdj)，验证码类型固定为“无验证码”
    try {
      this.selectedClub = 'gssjzdj'
      if (!this.config) this.config = {}
      this.config.captchaType = 'none'
      // 初始化 API 路径并加载对应配置
      this.updateApiPaths()
      this.loadClubConfig()
    } catch (e) {
      // 保底日志
      if (this.log) this.log('初始化配置时发生异常：' + e.message)
    }
  },
  methods: {
    // 显示手机号登录弹窗（要求已选择俱乐部）
    showPhoneLoginDialog () {
      if (!this.selectedClub) {
        this.log('错误：请先选择平台/俱乐部！')
        return
      }
      this.phoneLoginDialog.visible = true
    },
    // 关闭手机号登录弹窗并重置状态
    closePhoneLoginDialog () {
      this.phoneLoginDialog.visible = false
      this.phoneLoginDialog.phone = ''
      this.phoneLoginDialog.smsCode = ''
      this.phoneLoginDialog.gettingSms = false
      this.phoneLoginDialog.logging = false
      if (this.phoneLoginDialog.countdownTimer) {
        clearInterval(this.phoneLoginDialog.countdownTimer)
        this.phoneLoginDialog.countdownTimer = null
      }
      this.phoneLoginDialog.smsCountdown = 0
    },
    // 启动短信验证码倒计时
    startSmsCountdown (seconds = 60) {
      this.phoneLoginDialog.smsCountdown = seconds
      if (this.phoneLoginDialog.countdownTimer) {
        clearInterval(this.phoneLoginDialog.countdownTimer)
      }
      this.phoneLoginDialog.countdownTimer = setInterval(() => {
        if (this.phoneLoginDialog.smsCountdown > 0) {
          this.phoneLoginDialog.smsCountdown--
        } else {
          clearInterval(this.phoneLoginDialog.countdownTimer)
          this.phoneLoginDialog.countdownTimer = null
        }
      }, 1000)
    },
    // 获取短信验证码：获取图片验证码 -> （代理：OCR｜直连：人工输入）-> 提交图片验证码 -> 发送短信
    async getSmsCode () {
      if (!this.selectedClub) {
        this.log('错误：请先选择平台/俱乐部！')
        return
      }
      const phone = (this.phoneLoginDialog.phone || '').trim()
      if (!/^1\d{10}$/.test(phone)) {
        this.log('错误：请输入有效的11位手机号！')
        return
      }
      if (this.phoneLoginDialog.smsCountdown > 0 || this.phoneLoginDialog.gettingSms) return

      this.phoneLoginDialog.gettingSms = true
      // 日志提示不再固定为自动识别，兼容直连模式的人工输入
      this.log('开始获取短信验证码：准备获取图片验证码...')

      // 与刷新接口保持一致：在调用前确保API路径已更新（直连/代理由统一方法决定）
      this.updateApiPaths()

      // 重试机制：最多重试5次
      const maxRetries = 5
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          // 1) 获取图片验证码（强制直连目标站点，不走代理）
          const imgResp = await this.directApiCall('/api/user/getLoginSmsCodeImageVerify', 'POST', { phone })
          if (!imgResp || imgResp.code !== 1 || !imgResp.data || !imgResp.data.base64) {
            this.log(`第${attempt}次：获取图片验证码失败，准备重试...`)
            continue
          }
          const base64Url = imgResp.data.base64 // 形如 data:image/png;base64,XXXXX
          const commaIdx = base64Url.indexOf('base64,')
          const pureBase64 = commaIdx !== -1 ? base64Url.substring(commaIdx + 7) : base64Url

          // 2) 根据代理开关决定识别方式
          let imgCode = ''
          if (proxyConfig.isProxyEnabled()) {
            // 代理模式：OCR 自动识别
            const ocrUrl = '/api/ocr/alphabet'
            const ocrResp = await this.externalApiCall(ocrUrl, 'POST', { img_base64: pureBase64 })
            if (!ocrResp || !ocrResp.result) {
              this.log(`第${attempt}次：OCR识别失败，准备重试...`)
              continue
            }
            imgCode = (ocrResp.result || '').trim()
            if (!imgCode) {
              this.log(`第${attempt}次：OCR结果为空，准备重试...`)
              continue
            }
          } else {
            // 直连模式：弹出图片验证码输入框，等待用户输入
            this.log('直连模式：请手动输入图片验证码。')
            imgCode = await this.promptImageCaptcha(base64Url)
            if (!imgCode) {
              // 用户取消或未输入，结束当前流程
              this.log('未输入图片验证码，本次获取短信已取消。')
              this.phoneLoginDialog.gettingSms = false
              return
            }
          }

          // 3) 提交图片验证码，触发短信发送（强制直连目标站点，不走代理）
          const submitResp = await this.directApiCall('/api/user/loginSmsCodeImageVerifySubmit', 'POST', {
            phone,
            code: imgCode,
            params: {}
          })
          if (submitResp && submitResp.code === 1) {
            this.log('图片验证码验证成功，短信验证码已发送！')
            this.startSmsCountdown(60)
            this.phoneLoginDialog.gettingSms = false
            return
          }
          this.log(`第${attempt}次：提交图片验证码失败：${submitResp && submitResp.msg ? submitResp.msg : '未知错误'}，准备重试...`)
        } catch (e) {
          this.log(`第${attempt}次：发生异常：${e.message}，准备重试...`)
        }
        // 间隔1秒后重试
        await this.sleep(1000)
      }

      this.log('❌ 获取短信验证码失败：已达到最大重试次数，请稍后重试。')
      if (this.$message) {
        this.$message({ type: 'error', message: '获取短信验证码失败，请稍后重试' })
      }
      this.phoneLoginDialog.gettingSms = false
    },
    // 使用短信验证码进行手机号登录
    async phoneLogin () {
      if (!this.selectedClub) {
        this.log('错误：请先选择平台/俱乐部！')
        return
      }
      const phone = (this.phoneLoginDialog.phone || '').trim()
      const code = (this.phoneLoginDialog.smsCode || '').trim()
      if (!/^1\d{10}$/.test(phone)) {
        this.log('错误：请输入有效的11位手机号！')
        return
      }
      if (!code) {
        this.log('错误：请输入短信验证码！')
        return
      }
      if (this.phoneLoginDialog.logging) return

      this.phoneLoginDialog.logging = true
      this.log('正在进行手机号登录...')
      // 与刷新接口保持一致：在调用前确保API路径已更新（直连/代理由统一方法决定）
      this.updateApiPaths()
      try {
        // 手机号登录使用直连，确保不会变成 http://localhost:8080/api/<club>/...
        const resp = await this.directApiCall('/api/user/phoneLogin', 'POST', { phone, code })
        if (resp && resp.code === 1 && resp.data) {
          const uid = resp.data.user_id
          const utoken = resp.data.user_token
          this.config.userId = uid
          this.config.userToken = utoken
          this.log('✅ 登录成功，已自动填充用户ID与令牌！')
          this.closePhoneLoginDialog()
        } else {
          this.log(`❌ 登录失败：${resp && resp.msg ? resp.msg : '未知错误'}`)
          if (this.$message) {
            this.$message({ type: 'error', message: '登录失败，请稍后重试' })
          }
        }
      } catch (e) {
        this.log(`❌ 登录异常：${e.message}`)
        if (this.$message) {
          this.$message({ type: 'error', message: '登录异常，请稍后重试' })
        }
      } finally {
        this.phoneLoginDialog.logging = false
      }
    },
    // ...其他方法
    // 生成星星样式
    getStarStyle (index) {
      return {
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        animationDelay: Math.random() * 3 + 's',
        animationDuration: (Math.random() * 2 + 2) + 's'
      }
    },
    // 生成粒子样式
    getParticleStyle (index) {
      return {
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        animationDelay: Math.random() * 5 + 's',
        animationDuration: (Math.random() * 3 + 4) + 's'
      }
    },
    log (message) {
      const timestamp = new Date().toLocaleTimeString()
      this.logs.push(`[${timestamp}] ${message}`)
      this.$nextTick(() => {
        if (this.$refs.logBox) {
          this.$refs.logBox.scrollTop = this.$refs.logBox.scrollHeight
        }
      })
    },
    handleClubChange () {
      this.loadClubConfig()
      this.updateApiPaths()
    },
    updateApiPaths () {
      // 根据是否启用代理，动态设置API基础路径
      if (!this.selectedClub) return
      // 直接使用所选俱乐部作为子域名（不做别名映射）
      const clubForHost = this.selectedClub
      // 目标后端Host（用于必要的头部）
      this.currentApiHost = `${clubForHost}.${this.baseDomain}`
      // 俱乐部相关接口统一直连目标域名（不走本地代理）
      this.currentApiBase = `https://${this.currentApiHost}`
      this.log(`平台已切换, API Host: ${this.currentApiHost}`)
    },
    // 验证令牌方法
    async verifyToken () {
      if (!this.config.userId || !this.config.userToken || !this.selectedClub) {
        this.log('错误：请先选择平台并填写用户ID和用户令牌！')
        return
      }
      
      this.isVerifying = true
      this.log('正在验证令牌...')
      
      try {
        // 确保API路径已设置
        this.updateApiPaths()
        
        // 调用查询订单接口来验证凭据
        const response = await this.queryOrders()
        
        if (response && response.code === 1) {
          this.log('✅ 令牌验证成功！凭据有效，可以正常使用。')
          // 成功提示（绿色）
          if (this.$message) {
            this.$message({ type: 'success', message: '令牌验证成功' })
          }
        } else if (response && response.msg) {
          this.log(`❌ 令牌验证失败：${response.msg}`)
          if (response.msg.includes('登录') || response.msg.includes('token') || response.msg.includes('令牌')) {
            this.log('提示：请检查用户ID和用户令牌是否正确，或者令牌是否已过期。')
          }
          // 失败提示（红色）
          if (this.$message) {
            this.$message({ type: 'error', message: '令牌验证失败，请检查后重试' })
          }
        } else {
          this.log('❌ 令牌验证失败：无法连接到服务器或返回数据异常。')
          if (this.$message) {
            this.$message({ type: 'error', message: '令牌验证失败：无法连接到服务器或返回数据异常' })
          }
        }
      } catch (error) {
        this.log(`❌ 令牌验证失败：${error.message}`)
        if (this.$message) {
          this.$message({ type: 'error', message: '令牌验证失败，请稍后重试' })
        }
      } finally {
        this.isVerifying = false
      }
    },
    async apiCall (endpoint, method = 'GET', body = null) {
      if (!this.currentApiBase || !this.currentApiHost) {
        this.log('错误：API 地址未设置。请选择一个平台。')
        return null
      }
      const url = `${this.currentApiBase}${endpoint}`
      // 直连跨域调用时，避免手动设置受限头部（Origin/Referer/Sec-Fetch-*），减少预检与被浏览器拦截风险
      const headers = {
        'user-id': this.config.userId,
        'user-token': this.config.userToken,
        'platform': '3',
        'content-type': 'application/json',
        'Accept': '*/*'
      }
      try {
        const response = await fetch(url, {
          method,
          headers,
          body: body ? JSON.stringify(body) : null
        })
        if (!response.ok) throw new Error(`HTTP 错误! 状态: ${response.status}`)
        return await response.json()
      } catch (error) {
        this.log(`API 请求失败: ${endpoint} - ${error.message}`)
        return null
      }
    },
    // 直连俱乐部域名的 API 调用（不走代理，避免出现 localhost:8080/api/<club>/...）
    async directApiCall (endpoint, method = 'GET', body = null) {
      if (!this.selectedClub) {
        this.log('错误：请先选择平台/俱乐部！')
        return null
      }
      const clubHost = `${this.selectedClub}.${this.baseDomain}`
      const base = `https://${clubHost}`
      const url = `${base}${endpoint}`
      const headers = {
        // 直连时不要设置受限请求头（如 Host、Origin、Sec-Fetch-*、User-Agent），避免被浏览器拦截
        'user-id': this.config.userId,
        'user-token': this.config.userToken,
        'platform': '3',
        'content-type': 'application/json',
        'Accept': '*/*',
        'Referer': `${base}/h5/`
      }
      try {
        const response = await fetch(url, {
          method,
          headers,
          body: body ? JSON.stringify(body) : null
        })
        if (!response.ok) throw new Error(`HTTP 错误! 状态: ${response.status}`)
        return await response.json()
      } catch (error) {
        this.log(`直连 API 请求失败: ${endpoint} - ${error.message}`)
        return null
      }
    },
    async queryOrders () {
      return this.apiCall('/api/servant/getOrderList?limit=100&page=1&pages=0&goods_id=&game_server=&club_id=')
    },
    async getOrderCaptcha (orderId) {
      const resp = await this.apiCall('/api/servant/getTakingOrderVerifyCode', 'POST', { id: Number(orderId) })
      // 失败提示（红色）- 使用通用文案，避免暴露后端信息
      if (!resp || resp.code !== 1) {
        if (this.$message) {
          this.$message({ type: 'error', message: '获取抢单验证码失败，请稍后重试' })
        }
      }
      return resp
    },
    async acceptOrderWithCaptcha (orderId, code) {
      const resp = await this.apiCall('/api/servant/submitTakingOrderVerifyCode', 'POST', { id: Number(orderId), code, params: {} })
      if (resp && resp.code === 1) {
        // 保留成功提示
        if (this.$message) {
          this.$message({ type: 'success', message: '抢单成功（验证码）' })
        }
      } else {
        if (this.$message) {
          this.$message({ type: 'error', message: '抢单失败（验证码），请稍后重试' })
        }
      }
      return resp
    },
    async acceptOrderNoCaptcha (orderId) {
      const resp = await this.apiCall('/api/servant/takingOrder', 'POST', { id: Number(orderId) })
      if (resp && resp.code === 1) {
        if (this.$message) {
          this.$message({ type: 'success', message: '抢单成功' })
        }
      } else {
        if (this.$message) {
          this.$message({ type: 'error', message: '抢单失败，请稍后重试' })
        }
      }
      return resp
    },
    // 外部API调用方法 - 简化版本，去除不必要的头部信息
    async externalApiCall (url, method = 'GET', body = null) {
      try {
        const response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*'
          },
          body: body ? JSON.stringify(body) : null
        })
        if (!response.ok) throw new Error(`HTTP 错误! 状态: ${response.status}`)
        return await response.json()
      } catch (error) {
        this.log(`外部API调用失败: ${url} - ${error.message}`)
        return null
      }
    },
    // 获取滑块验证码 - 通过代理接口调用
    async getSliderCaptcha () {
      try {
        // 通过本地代理转发到 hongchen8.asia（见 config/index.js 的 /api/config 配置）
        const url = '/api/config/slider'
        const data = await this.externalApiCall(url)

        // 期望返回结构：{ code: 200, message: '获取成功', data: { ticket: '...', randstr: '...' } }
        if (data && data.code === 200 && data.data && data.data.ticket && data.data.randstr) {
          return {
            ticket: data.data.ticket,
            randstr: data.data.randstr
          }
        }

        this.log('获取验证码数据异常，返回数据中不包含有效的 ticket/randstr')
        if (this.$message) {
          this.$message({ type: 'error', message: '获取滑块验证码失败，请稍后重试' })
        }
        return null
        
      } catch (error) {
        this.log(`获取滑块验证码失败: ${error.message}`)
        if (this.$message) {
          this.$message({ type: 'error', message: '获取滑块验证码失败，请稍后重试' })
        }
        return null
      }
    },
    // 使用滑块验证码抢单
    async acceptOrderWithSlider (orderId, ticket, randstr) {
      const params = {
        appid: '192294958',
        ret: 0,
        ticket: ticket,
        randstr: randstr,
        verifyDuration: 262,
        actionDuration: 2345,
        sid: '7354076446876196864'
      }
      const resp = await this.apiCall('/api/servant/submitTakingOrderVerifyCode', 'POST', {
        id: Number(orderId),
        code: '',
        params: params
      })
      if (resp && resp.code === 1) {
        if (this.$message) {
          this.$message({ type: 'success', message: '抢单成功（滑块）' })
        }
      } else {
        if (this.$message) {
          this.$message({ type: 'error', message: '抢单失败（滑块），请稍后重试' })
        }
      }
      return resp
    },
    async solveCaptcha (base64Image) {
      if (!this.config.ocrApiUrl) {
        this.log('OCR API 地址未设置。')
        return null
      }
      this.log('正在识别图片验证码...')
      try {
        const response = await fetch(this.config.ocrApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 'string': base64Image })
        })
        const data = await response.json()
        if (data && data.result) {
          this.log(`验证码识别成功: ${data.result}`)
          return data.result
        }
        this.log(`验证码识别失败: ${JSON.stringify(data)}`)
        return null
      } catch (error) {
        this.log(`调用 OCR API 失败: ${error.message}`)
        return null
      }
    },
    saveClubConfig () {
      if (!this.selectedClub) return
      this.log(`正在为俱乐部 [${this.selectedClub}] 保存配置...`)
      localStorage.setItem(`config_${this.selectedClub}`, JSON.stringify(this.config))
      localStorage.setItem('lastSelectedClub', this.selectedClub)
      this.log('配置已保存。')
    },
    loadClubConfig () {
      if (!this.selectedClub) return
      const savedConfig = localStorage.getItem(`config_${this.selectedClub}`)
      if (savedConfig) {
        this.log(`为俱乐部 [${this.selectedClub}] 加载已保存的配置...`)
        this.config = { ...this.config, ...JSON.parse(savedConfig) }
      } else {
        this.log(`俱乐部 [${this.selectedClub}] 无保存配置，已重置为默认值。`)
        this.resetConfig()
      }
    },
    resetConfig () {
      this.config = {
        userId: '',
        userToken: '',
        matchKeywords: false,
        keywords: '',
        matchBoss: false,
        bossKeywords: '',
        matchPrice: false,
        minFee: 0,
        excludeKeywords: false, // 是否启用不匹配关键词过滤
        excludeKeywordsList: '', // 不匹配关键词列表，用|分隔
        serverTypeFilter: '全部', // 服务器类型过滤：手机端, 电脑端, QQ区, 微信区

        excludeWithRemarks: false,
        filterRemarks: false,
        remarkFilterKeywords: '',
        captchaType: 'none', // 验证码类型：none-无验证码, slider-滑块验证码
        ocrApiUrl: 'https://frp-gap.com:30507/api/ocr/alphabet',
        refreshDelay: 2000,
        grabDelay: 0 // 抢单延迟（毫秒）：发现符合条件订单后等待的毫秒数
      }
    },
    async startGrabbing () {
      if (!this.config.userId || !this.config.userToken) {
        alert('请先填写用户ID和用户令牌！')
        return
      }
      if (!this.selectedClub) {
        alert('请先选择一个平台！')
        return
      }
      // 确保 API 地址正确设置
      this.updateApiPaths()
      this.saveClubConfig()
      this.isGrabbing = true
      this.log('抢单循环已启动。')
      await this.mainLoop()
    },
    stopGrabbing () {
      this.isGrabbing = false
      this.log('手动停止抢单...')
    },
    async mainLoop () {
      while (this.isGrabbing) {
        const orderResponse = await this.queryOrders()
        if (!orderResponse) {
          this.log('无法获取订单列表，等待下一次刷新...')
          await this.sleep(this.config.refreshDelay)
          continue
        }
        if (orderResponse.code !== 1) {
          // 过滤掉"请求过于频繁"的错误信息，避免日志刷屏
          if (!orderResponse.msg || !orderResponse.msg.includes('请求过于频繁')) {
            this.log(`获取订单失败: ${orderResponse.msg}`)
          }
          if (orderResponse.msg && orderResponse.msg.includes('登录')) {
            this.log('Token 可能已过期，请更新后重试。')
            this.isGrabbing = false
            return
          }
          await this.sleep(this.config.refreshDelay)
          continue
        }

        this.orders = orderResponse.data.list || []
        let grabSuccess = false
        for (const order of this.orders) {
          if (!this.isGrabbing) break
          if (this.canGrabOrder(order)) {
            this.log(`<span style="color: #ffd700;">发现可抢订单: ${order.goods_name} (ID: ${order.id})，准备抢单...</span>`)
            const success = await this.tryGrabOrder(order)
            // 只有抢单成功时才停止循环
            if (success) {
              grabSuccess = true
              break
            }
            // 如果抢单失败，继续寻找下一个可抢的订单
          }
        }
        // 只有抢单成功时才退出主循环
        if (grabSuccess) break
        await this.sleep(this.config.refreshDelay)
      }
      this.log('抢单循环已停止。')
      this.isGrabbing = false
    },
    canGrabOrder (order) {
      if (order.apply_refund_status === '1') return false
      if (order.goods_luck_already_count !== order.goods_luck_count) return false
      // 服务器类型过滤：只允许选中的类型通过，如果选择"全部"则不过滤
      if (this.config.serverTypeFilter !== '全部' && order.game_server_name !== this.config.serverTypeFilter) return false
      if (this.config.excludeWithRemarks && order.remarks !== '') return false
      if (this.config.matchPrice && parseFloat(order.servant_fee) <= parseFloat(this.config.minFee)) return false

      if (this.config.matchKeywords) {
        const keywords = this.config.keywords.split('|').filter(k => k)
        if (keywords.length > 0 && !keywords.some(k => order.goods_name.includes(k))) return false
      }

      if (this.config.matchBoss) {
        const bossKeywords = this.config.bossKeywords.split('|').filter(k => k)
        const bossName = order.user_info && order.user_info.user_level && order.user_info.user_level.name
        if (bossKeywords.length > 0 && (!bossName || !bossKeywords.some(k => bossName.includes(k)))) return false
      }

      if (this.config.filterRemarks) {
        const remarkFilterKeywords = this.config.remarkFilterKeywords.split('|').filter(k => k)
        if (remarkFilterKeywords.length > 0 && remarkFilterKeywords.some(k => order.remarks.includes(k))) return false
      }

      // 不匹配关键词过滤：包含指定关键词的订单不会抢
      if (this.config.excludeKeywords) {
        const excludeKeywords = this.config.excludeKeywordsList.split('|').filter(k => k.trim())
        if (excludeKeywords.length > 0 && excludeKeywords.some(k => order.goods_name.includes(k.trim()))) {
          return false
        }
      }

      return true
    },
    async tryGrabOrder (order) {
      if (!this.isGrabbing) return false
      
      // 最多3次重试逻辑
      for (let attempt = 1; attempt <= 3; attempt++) {
        if (!this.isGrabbing) return false
        
        if (attempt > 1) {
          this.log(`抢单尝试第 ${attempt} 次...`)
        }
        
        let acceptResponse
        if (this.config.captchaType === 'slider') {
          // 滑块验证码模式
          const sliderData = await this.getSliderCaptcha()
          if (sliderData && sliderData.ticket && sliderData.randstr) {
            await this.sleep(this.config.grabDelay)
            acceptResponse = await this.acceptOrderWithSlider(order.id, sliderData.ticket, sliderData.randstr)
          } else {
            this.log('获取滑块验证码失败，跳过此订单。')
            return false
          }
        } else if (this.config.captchaType === 'image') {
          // 图片验证码模式：获取图片 -> （代理模式：OCR识别｜直连模式：人工输入） -> 提交
          const imgResp = await this.getOrderCaptcha(order.id)
          if (!imgResp || imgResp.code !== 1 || !imgResp.data) {
            this.log('获取图片验证码失败，跳过此订单。')
            return false
          }
          // 兼容不同字段命名，优先 data.base64，其次 data.image
          const base64Url = imgResp.data.base64 || imgResp.data.image || ''
          if (!base64Url) {
            this.log('返回的数据不包含图片验证码，跳过此订单。')
            return false
          }
          let imgCode = ''
          // 根据是否启用代理，决定 OCR 还是人工输入
          if (proxyConfig.isProxyEnabled()) {
            // 代理模式：走 OCR 自动识别
            // 提取纯 base64 内容给 OCR 使用
            const commaIdx = base64Url.indexOf('base64,')
            const pureBase64 = commaIdx !== -1 ? base64Url.substring(commaIdx + 7) : base64Url
            // 调用与短信登录相同的 OCR 接口（通过代理），提高兼容性
            const ocrResp = await this.externalApiCall('/api/ocr/alphabet', 'POST', { img_base64: pureBase64 })
            if (!ocrResp || !ocrResp.result) {
              this.log('OCR 识别图片验证码失败，跳过此订单。')
              return false
            }
            imgCode = (ocrResp.result || '').trim()
            if (!imgCode) {
              this.log('OCR 识别结果为空，跳过此订单。')
              return false
            }
          } else {
            // 直连模式：弹出图片供用户手动输入验证码
            this.log('直连模式：请手动输入图片验证码。')
            imgCode = await this.promptImageCaptcha(base64Url)
            if (!imgCode) {
              this.log('未输入图片验证码，跳过此订单。')
              return false
            }
          }
          await this.sleep(this.config.grabDelay)
          acceptResponse = await this.acceptOrderWithImage(order.id, base64Url, imgCode)
        } else {
          // 无验证码模式
          await this.sleep(this.config.grabDelay)
          acceptResponse = await this.acceptOrderNoCaptcha(order.id)
        }

        if (acceptResponse) {
          if (acceptResponse.code === 1) {
            this.log(`<span style="color: #4caf50;">🎉 抢单成功! 商品: ${order.goods_name}</span>`)
            // 去除弹窗提示，只保留日志和音乐提示
            this.playMusic(true)
            return true
          } else {
            const msg = acceptResponse.msg || ''
            this.log(`抢单失败: ${msg}`)
            
            // 已被接单 -> 停止重试
            if (msg.includes('已被接单') || msg.includes('被接单')) {
              this.log('该订单已被接单，停止重试')
              return false
            }
            
            // 接单频繁 -> 等待1秒后重试
            if (msg.includes('接单频繁')) {
              this.log('接单频繁，等待 1 秒后重试')
              await this.sleep(1000)
              continue
            }
            
            // 等级限制等其他情况 -> 等待指定秒数
            if (acceptResponse.code === 20008) {
              const waitSec = this.parseWaitSecondsFromMsg(msg)
              if (waitSec > 0) {
                this.log(`检测到等级限制，将等待 ${waitSec} 秒后继续...`)
                await this.sleep(waitSec * 1000 + parseInt(this.config.limitDelay || 0))
                continue
              }
            }
            
            // 其他失败情况，如果还有重试次数就继续，否则结束
            if (attempt < 3) {
              this.log(`第 ${attempt} 次尝试失败，准备重试`)
              continue
            }
          }
        }
      }
      
      this.log('已达到最大重试次数，结束本次订单尝试')
      return false
    },
      // 解析需要等待的秒数（从返回msg中提取"xx秒"数字）
    parseWaitSecondsFromMsg(msg) {
      if (!msg || typeof msg !== 'string') return 0
      // 简化处理：优先匹配"xx秒"
      const m = msg.match(/(\d+)\s*秒/)
      if (m && m[1]) {
        const sec = parseInt(m[1], 10)
        return isNaN(sec) ? 0 : sec
      }
      return 0
    },
    /**
     * 弹出图片验证码输入框，等待用户输入
     * @param {string} base64Url 带 data:image/...;base64, 前缀的图片地址
     * @returns {Promise<string|null>} 返回用户输入的验证码；取消/关闭时返回 null
     */
    async promptImageCaptcha (base64Url) {
      return new Promise((resolve) => {
        // 显示弹窗并保存resolver
        this.imageCaptchaDialog.visible = true
        this.imageCaptchaDialog.imageBase64Url = base64Url
        this.imageCaptchaDialog.code = ''
        this.imageCaptchaDialog.submitting = false
        this.imageCaptchaDialog._resolver = resolve
      })
    },
    // 提交图片验证码
    async submitImageCaptcha () {
      if (!this.imageCaptchaDialog.code) return
      try {
        this.imageCaptchaDialog.submitting = true
        const code = this.imageCaptchaDialog.code.trim()
        // 关闭弹窗并通过resolver返回
        const resolver = this.imageCaptchaDialog._resolver
        this.imageCaptchaDialog.visible = false
        this.imageCaptchaDialog.submitting = false
        this.imageCaptchaDialog._resolver = null
        if (resolver) resolver(code)
      } catch (e) {
        this.imageCaptchaDialog.submitting = false
      }
    },
    // 关闭图片验证码弹窗（视为取消）
    closeImageCaptchaDialog () {
      const resolver = this.imageCaptchaDialog._resolver
      this.imageCaptchaDialog.visible = false
      this.imageCaptchaDialog.submitting = false
      this.imageCaptchaDialog._resolver = null
      if (resolver) resolver(null)
    },
    // 使用图片验证码抢单
    async acceptOrderWithImage (orderId, imageBase64Url, code) {
      // 按接口要求提交：{"id":27491,"image":"data:image/png;base64,...","code":"XNY"}
      const payload = {
        id: Number(orderId),
        image: imageBase64Url,
        code: code
      }
      const resp = await this.apiCall('/api/servant/submitTakingOrderVerifyCode', 'POST', payload)
      if (resp && resp.code === 1) {
        if (this.$message) {
          this.$message({ type: 'success', message: '抢单成功（图片）' })
        }
      } else {
        if (this.$message) {
          this.$message({ type: 'error', message: '抢单失败（图片），请稍后重试' })
        }
      }
      return resp
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async showMyOrders () {
      if (!this.config.userId || !this.config.userToken) {
        alert('请先填写用户ID和用户令牌！')
        return
      }
      
      this.showOrdersModal = true
      this.log('正在获取待完成订单列表...')
      
      const response = await this.apiCall('/api/servant/getTakingOrderList?limit=10&page=1&pages=1&type=1&order_no=')
      if (response && response.code === 1) {
        this.myOrders = response.data.list || []
        this.log(`成功获取 ${this.myOrders.length} 个待完成订单`)
      } else {
        this.log(`获取待完成订单失败: ${response ? response.msg : '未知错误'}`)
        if (response && response.msg && response.msg.includes('登录')) {
          this.log('Token 可能已过期，请更新后重试。')
        }
      }
    },
    
    closeOrdersModal () {
      this.showOrdersModal = false
      this.myOrders = []
    },
    
    formatTime (timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    },
    
    copyOrderInfo (order) {
      const copyText = this.copyTemplate
        .replace('{ordernum}', order.order_no || '')
        .replace('{nameid}', order.game_id || '')
        .replace('{gamename}', order.extra_from_data && order.extra_from_data[0] ? order.extra_from_data[0].value : '')
        .replace('{phone}', (order.user_info && order.user_info.phone) ? order.user_info.phone : '')
      
      // 复制到剪贴板：HTTPS 优先使用 Clipboard API；HTTP 降级使用 textarea + execCommand
      const fallbackCopy = (text) => {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.top = '-1000px'
        textarea.style.left = '-1000px'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        let ok = false
        try {
          ok = document.execCommand('copy')
        } catch (e) {
          ok = false
        }
        document.body.removeChild(textarea)
        if (ok) {
          this.log('订单信息已复制到剪贴板')
          if (this.$message) this.$message({ type: 'success', message: '复制成功' })
        } else {
          this.log('复制失败')
          if (this.$message) this.$message({ type: 'error', message: '复制失败' })
        }
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(copyText).then(() => {
          this.log('订单信息已复制到剪贴板')
          if (this.$message) this.$message({ type: 'success', message: '复制成功' })
        }).catch(() => {
          fallbackCopy(copyText)
        })
      } else {
        fallbackCopy(copyText)
      }
    },
    
    async playMusic (continuous = false) {
      if (this.isPlayingMusic && !continuous) return
      
      this.isPlayingMusic = true
      this.isContinuousPlay = continuous
      this.musicPlayCount = 0
      
      const audio = this.$refs.audioPlayer
      if (!audio) {
        this.log('音频播放器未找到')
        return
      }
      
      if (this.playNextHandler) {
        audio.removeEventListener('ended', this.playNextHandler)
      }
      
      this.playNextHandler = () => {
        if (this.isContinuousPlay) {
          audio.currentTime = 0
          audio.play()
          this.musicPlayCount++
          this.log(`播放音乐 (持续播放中，已播放 ${this.musicPlayCount} 次)`)
        } else {
          this.log('测试音乐播放完成')
          this.stopMusic()
        }
      }
      
      audio.addEventListener('ended', this.playNextHandler)
      audio.currentTime = 0
      audio.play()
      if (continuous) {
        this.log('开始持续播放音乐')
      } else {
        this.log('开始测试播放音乐')
      }
    },
    
    stopMusic () {
      const audio = this.$refs.audioPlayer
      if (audio && this.playNextHandler) {
        audio.pause()
        audio.currentTime = 0
        audio.removeEventListener('ended', this.playNextHandler)
        this.playNextHandler = null
      }
      this.isPlayingMusic = false
      this.isContinuousPlay = false
      this.musicPlayCount = 0
      this.log('音乐已停止')
    },
    
    testPlayMusic () {
      if (this.isPlayingMusic) {
        this.log('停止音乐播放...')
        this.stopMusic()
      } else {
        this.log('测试音乐播放...')
        this.playMusic(false)
      }
    },
    
    // 获取公告信息
    async fetchAnnouncement () {
      try {
        const announcementUrl = proxyConfig.getAnnouncementUrl()
        this.log('正在获取公告信息...')
        
        const response = await fetch(announcementUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36'
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }
        
        const result = await response.text()
        
        // 将公告内容加入日志
        if (result && result.trim()) {
          this.log(`<span style="color: #4fc3f7;">ℹ️ 公告信息：${result}</span>`)
        } else {
          this.log('ℹ️ 暂无公告信息')
        }
        
        return result
      } catch (error) {
        this.log(`获取公告信息失败：${error.message}`)
        return null
      }
    },
    
    // 根据true/false模式进行不同的业务逻辑
    handleModeSwitch () {
      const isProxyMode = proxyConfig.isProxyEnabled()
      
      // 内部逻辑处理，不向用户显示技术细节
      if (isProxyMode) {
        // 代理模式的业务逻辑
        console.log('使用代理模式')
      } else {
        // 直连模式的业务逻辑
        console.log('使用直连模式')
      }
      
      return isProxyMode
    },
    /**
     * 从配置接口获取俱乐部列表
     * - 成功：用接口返回的数组覆盖默认 clubs
     * - 失败：保留默认 clubs
     */
    async loadClubsFromApi () {
      try {
        // 获取俱乐部配置接口地址
        const url = proxyConfig.getClubApiUrl()
        // 直接请求配置接口（返回值为一个可直接使用的 JSON 数组）
        const resp = await fetch(url)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const data = await resp.json()
        if (Array.isArray(data) && data.length >= 0) {
          this.clubs = data
          this.log('已从接口加载俱乐部配置。')
          // 如果本地之前选择的俱乐部不在新列表中，这里不强制重置，交由用户自行选择
        } else {
          this.log('接口返回的俱乐部配置为空，已使用默认配置。')
        }
      } catch (e) {
        // 网络错误或解析异常时，回退默认 clubs
        this.log(`加载俱乐部配置失败：${e.message}，已使用默认配置。`)
      }
    }
  },
  watch: {
    // 监听配置变化，实时保存到localStorage
    config: {
      handler () {
        if (this.selectedClub) {
          this.saveClubConfig()
        }
      },
      deep: true // 深度监听对象属性变化
    }
  },
  mounted () {
    const lastSelectedClub = localStorage.getItem('lastSelectedClub')
    if (lastSelectedClub) {
      this.selectedClub = lastSelectedClub
      this.loadClubConfig()
    }
    // 尝试从接口获取俱乐部配置，若失败则继续使用默认配置
    // this.loadClubsFromApi()
    // this.log('抢单工具已就绪。请选择平台，填写配置后点击开始。')
    // this.log('提醒：每个平台的配置都是独立保存和加载的。')
    
    // 检查当前模式并显示
    this.handleModeSwitch()
    
    // 获取公告信息
    // this.fetchAnnouncement()
  }
}
</script>

<style scoped>
.container {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 1400px;
  padding: 8px;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
}

.panel {
  background-color: #252526;
  border: 1px solid #3c3c3c;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

.settings-panel {
  flex: 0 0 520px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.main-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 85vh;
  overflow-y: auto;
  min-width: 0;
}

h2, h3 {
  color: #dcdcaa;
  margin-top: 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid #3c3c3c;
  padding-bottom: 4px;
  font-size: 15px;
}

/* 第一个标题不需要上边距 */
h2:first-of-type {
  margin-top: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 3px;
}

.form-group-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 一行显示多个表单项的样式 */
.form-group.form-row {
  display: flex !important;
  flex-direction: row !important;
  gap: 12px;
  align-items: flex-end;
}

.form-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.form-item label {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 1px;
  white-space: nowrap;
}

.form-item input,
.form-item select {
  width: 100%;
  min-width: 0;
}

/* form-item内部的form-group-row样式 */
.form-item .form-group-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.form-item .form-group-row input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.form-item .form-group-row label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
}

/* 新的checkbox-label样式 */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0;
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 2px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
  margin-right: 4px;
  flex-shrink: 0;
  width: auto;
}

label {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 2px;
}

/* 输入框和选择框的紧凑样式 */
input[type="text"], input[type="password"], input[type="number"], select {
  background-color: #3c3c3c;
  border: 1px solid #555;
  border-radius: 4px;
  color: #dcdcaa;
  padding: 4px 6px;
  font-size: 13px;
  width: 100%;
  box-sizing: border-box;
  height: 28px;
}

input[type="text"]:focus, input[type="password"]:focus, input[type="number"]:focus, select:focus {
  outline: none;
  border-color: #007acc;
  box-shadow: 0 0 3px rgba(0, 122, 204, 0.3);
}

/* 复选框样式 */
input[type="checkbox"] {
  margin-right: 6px;
  transform: scale(1.1);
  flex-shrink: 0;
}

/* 按钮的紧凑样式 */
button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
  height: 36px;
  min-width: 100px;
}

.btn-start {
  background-color: #4caf50;
  color: white;
}

.btn-start:disabled {
  background-color: #385a3a;
}

.btn-stop {
  background-color: #f44336;
  color: white;
}

.btn-stop:disabled {
  background-color: #6d332e;
}

.btn-view {
  background-color: #2196F3;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-view:hover {
  background-color: #1976D2;
}

.btn-test {
  background-color: #9c27b0;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-test:hover {
  background-color: #7b1fa2;
}

.btn-verify {
  background-color: #ff9800;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  min-width: 100px;
}

.btn-verify:hover {
  background-color: #f57c00;
}

.btn-verify:disabled {
  background-color: #8d6e63;
  cursor: not-allowed;
}

.log-box {
  background-color: #1e1e1e;
  border: 1px solid #3c3c3c;
  height: 200px;
  overflow-y: scroll;
  padding: 8px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  border-radius: 4px;
  line-height: 1.3;
}

/* 手机号登录弹窗覆盖层与对话框样式 */
.phone-login-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* 高于页面其它内容 */
}

.phone-login-dialog {
  width: 360px;
  max-width: 90vw;
  background: #2d2d30;
  border: 1px solid #3c3c3c;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.4);
  color: #ddd;
}

.phone-login-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #3c3c3c;
}

.phone-login-dialog .dialog-header h3 {
  margin: 0;
  font-size: 16px;
  color: #dcdcaa;
}

.phone-login-dialog .dialog-header .close-btn {
  background: transparent;
  color: #ccc;
  border: none;
  font-size: 20px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.phone-login-dialog .dialog-content {
  padding: 12px;
}

.phone-login-dialog .form-group {
  margin-bottom: 10px;
}

.phone-login-dialog input[type="text"] {
  background-color: #3c3c3c;
  border: 1px solid #555;
  border-radius: 4px;
  color: #dcdcaa;
  padding: 6px 8px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  height: 34px;
}

.sms-input-group {
  display: flex;
  gap: 8px;
}

.get-sms-btn {
  background-color: #2196F3;
  color: #fff;
  min-width: 110px;
}

.get-sms-btn:disabled {
  background-color: #4e6e8d;
  cursor: not-allowed;
}

.login-btn {
  background-color: #4caf50;
  color: #fff;
  width: 100%;
}

.login-btn:disabled {
  background-color: #385a3a;
}

/* 表格的紧凑样式 */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 8px;
}

th, td {
  border: 1px solid #3c3c3c;
  padding: 6px 8px;
  text-align: left;
  font-size: 13px;
}

th {
  background-color: #2d2d30;
  color: #dcdcaa;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

td {
  background-color: #252526;
  color: #cccccc;
}

tr:hover td {
  background-color: #2a2d2e;
}

/* 添加移动端响应式布局 */
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    padding: 4px;
    height: auto;
    min-height: 100vh;
    gap: 8px;
    overflow-y: auto;
  }

  .settings-panel {
    flex: none;
    width: 100%;
    max-height: none;
    overflow-y: visible;
    display: flex !important;
    flex-direction: column !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  
  /* 桌面版专用内容在手机版隐藏 */
  .desktop-only-content {
    display: none !important;
  }
  
  /* 手机版专用内容在桌面版隐藏，手机版显示 */
  .mobile-only-content {
    display: block !important;
  }

  .panel {
    padding: 10px;
    display: block !important;
    visibility: visible !important;
  }

  .form-group-row {
    flex-wrap: wrap;
  }

  /* 移动端form-row垂直排列 */
  .form-row {
    flex-direction: column;
    gap: 8px;
  }

  .form-item {
    width: 100%;
  }

  .log-box {
    height: 200px;
    display: block !important;
    visibility: visible !important;
    background-color: #1e1e1e !important;
    border: 1px solid #3c3c3c !important;
    overflow-y: auto !important;
  }

  table {
    font-size: 14px;
    display: table !important;
    width: 100% !important;
    visibility: visible !important;
  }

  th, td {
    padding: 6px;
  }

  /* 调整按钮在移动端的布局 */
  .form-group-row[style*="justify-content: space-around"] {
    flex-direction: column;
    gap: 10px;
  }

  .btn-start, .btn-stop, .btn-view, .btn-test {
    width: 100%;
  }
}

/* 桌面版：隐藏手机版专用内容 */
@media screen and (min-width: 769px) {
  .mobile-only-content {
    display: none !important;
  }
  
  .desktop-only-content {
    display: flex !important;
  }
}

/* 添加平板设备的响应式布局 */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .container {
    max-width: 100%;
  }

  .settings-panel {
    flex: 0 0 400px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #252526;
  border: 1px solid #3c3c3c;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #3c3c3c;
}

.modal-header h2 {
  margin: 0;
  color: #dcdcaa;
}

.close-btn {
  background: none;
  border: none;
  color: #dcdcaa;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
}

.btn-copy {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
}

.btn-copy:hover {
  background-color: #45a049;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 10px;
  }
  
  .modal-body {
    padding: 10px;
  }
  
  table {
    font-size: 12px;
  }
  
  th, td {
    padding: 4px;
  }
  
  .btn-copy {
    padding: 2px 4px;
    font-size: 11px;
  }
}

/* 星星动画背景 */
.stars-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
}

.star {
  position: absolute;
  width: 2px;
  height: 2px;
  background: #fff;
  border-radius: 50%;
  animation: twinkle linear infinite;
  box-shadow: 0 0 6px #fff, 0 0 12px #fff, 0 0 18px #4fc3f7;
}

.star:nth-child(2n) {
  background: #ffd700;
  box-shadow: 0 0 6px #ffd700, 0 0 12px #ffd700, 0 0 18px #ffd700;
}

.star:nth-child(3n) {
  background: #ff69b4;
  box-shadow: 0 0 6px #ff69b4, 0 0 12px #ff69b4, 0 0 18px #ff69b4;
}

.star:nth-child(4n) {
  background: #00ff7f;
  box-shadow: 0 0 6px #00ff7f, 0 0 12px #00ff7f, 0 0 18px #00ff7f;
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* 浮动粒子效果 */
.particles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: linear-gradient(45deg, #4fc3f7, #29b6f6);
  border-radius: 50%;
  animation: float linear infinite;
  opacity: 0.7;
}

.particle:nth-child(2n) {
  background: linear-gradient(45deg, #ffd700, #ffb300);
}

.particle:nth-child(3n) {
  background: linear-gradient(45deg, #ff69b4, #e91e63);
}

.particle:nth-child(4n) {
  background: linear-gradient(45deg, #00ff7f, #4caf50);
}

@keyframes float {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.7;
  }
  90% {
    opacity: 0.7;
  }
  100% {
    transform: translateY(-10vh) rotate(360deg);
    opacity: 0;
  }
}

/* 动态渐变背景 */
.container {
  background: linear-gradient(45deg, #0f0f0f, #1a1a1a, #2d2d2d, #1e1e1e);
  background-size: 400% 400%;
  animation: gradientShift 8s ease infinite;
  position: relative;
}

/* 动态渐变背景动画 */
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* 面板增加微妙的发光效果 */
.panel {
  box-shadow: 0 2px 8px rgba(0,0,0,0.3), 0 0 20px rgba(79, 195, 247, 0.1);
  transition: box-shadow 0.3s ease;
}

.panel:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.4), 0 0 30px rgba(79, 195, 247, 0.2);
}

/* 按钮增加发光动画 */
.btn-start:not(:disabled) {
  box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);
  animation: pulse-green 2s infinite;
}

.btn-stop:not(:disabled) {
  box-shadow: 0 0 10px rgba(244, 67, 54, 0.3);
  animation: pulse-red 2s infinite;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 10px rgba(76, 175, 80, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
  }
}

@keyframes pulse-red {
  0%, 100% {
    box-shadow: 0 0 10px rgba(244, 67, 54, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(244, 67, 54, 0.6);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/OrderGrabTool.vue